/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react";
import { useToast } from "@chakra-ui/react";

type Props = {
  title: string;
  status: "info" | "warning" | "success" | "error";
  description?: string; // 詳細メッセージ用のオプションフィールドを追加
};

export const useMessage = () => {
  const toast = useToast();

  const showMessage = useCallback((props: Props) => {
    const { title, status, description } = props;
    toast({
      title,
      description, // 詳細メッセージがある場合は表示
      status,
      position: "top",
      duration: 6000, // 表示時間を6秒に延長
      isClosable: true,
      variant: "solid", // より目立つデザイン
    });
  }, []);

  return { showMessage };
};
